const options = {
    selector: '.mu8-nav-switch',
};

/**
 * 初始化
 * @param {Object} newOptions 
 */
function init(newOptions) {
    if (newOptions) {
        Object.assign(options, newOptions);
    }

    if ($('.mu8-nav-shade').length === 0) {
        $('body').append('<div class="mu8-nav-shade"></div>');
    }

    $(options.selector).on('click', () => {
        toggle();
    });
    $('.mu8-nav-shade').on('click', () => {
        toggle();
    });

    // 初始化导航
    resize();

    // 绑定窗体改变大小事件
    window.onresize = function () {
        resize();
    };

}

/**
 * 菜单收缩开关
 */
function toggle() {
    if ($('body').hasClass('mu8-mobile')) {
        $('body').removeClass('mu8-mobile');
    } else {
        $('body').addClass('mu8-mobile');
    }
}

/**
 * 适配屏幕大小
 */
function resize() {
    // 小屏幕适配
    const checkedCatid = $('.mu8-nav').data('checked').toString();

    if (checkedCatid == '0') {
        $('.mu8-nav .layui-nav-item').eq(0).addClass('layui-this');
    }

    if ($('body').width() < 768) {
        $('.mu8-nav').addClass('layui-nav-tree layui-nav-side').find('.layui-nav-item').addClass('layui-nav-itemed');
    } else {
        $('.mu8-nav').removeClass('layui-nav-tree layui-nav-side').find('.layui-nav-item').removeClass('layui-nav-itemed');
        $('.mu8-nav .layui-nav-item').each((i, item) => {
            let children = $(item).data('children');
            if (typeof (children) === 'undefined') {
                return;
            }
            children = children.toString();
            if (children.split(',').indexOf(checkedCatid) !== -1) {
                $(item).addClass('layui-this');
            }
        });
    }
}

/**
 * 渲染内容
 * @param {Object} newOptions 
 */
function render(newOptions) {
    init(newOptions);
}

export default {
    init,
    render,
}